import { type EntityState, createEntityAdapter } from '@reduxjs/toolkit'
import { apiSlice } from '../../../app/api/apiSlice'
import { type ExperienceCard } from '../../experience/types/types'
import { type Student, type StudentSystemType } from '../../students/types/types'
import { type IResponseList } from '../../../types/types'

const experienceStudentAdptor = createEntityAdapter<ExperienceCard>({
  selectId: (experience) => experience._id
})

type ExperiencesForStudentInitialState = EntityState<ExperienceCard>

const initialState: ExperiencesForStudentInitialState =
  experienceStudentAdptor.getInitialState()

export const extendedExperiencesStudentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllExperienceStudent: builder.query<
    EntityState<ExperienceCard>,
    {
      currentSystem: string
      studentId: string
    }
    >({
      query: (data) =>
        `experience-card/expereincesstudent?studentId=${data.studentId}&currentSystem=${data.currentSystem}`,
      transformResponse: (response: IResponseList<ExperienceCard[]>) => {
     
        return experienceStudentAdptor.setAll(initialState, response.data);
      },
      // change the provideTags to the simple version
      providesTags: [
        'ExperienceStudent'
      ]
    }),

    updateExperienceStudent: builder.mutation<
    EntityState<ExperienceCard>,
    {
      experience: ExperienceCard
      student: Student
      complete: boolean
      currentSystem: StudentSystemType
    }
    >({
      query: (data) => ({
        url: '/experience-student-completion',
        method: 'PUT',
        body: data
      }),
      transformResponse: (response: ExperienceCard) => {
        return experienceStudentAdptor.updateOne(initialState, {
          id: response._id,
          changes: response
        })
      },
      invalidatesTags:  [
       "ExperienceStudent",
        "Student",
        "LeaderBoard",
        "ExperienceCard",
        "ProfileChart",
        "StudentCompletionPhoto",
      ],
    }),
  }),
});

export const {
  useGetAllExperienceStudentQuery,
  useUpdateExperienceStudentMutation
} = extendedExperiencesStudentApi
